/* Un menú que cuelga de un control. El panel se posiciona en fijo (ver
   `useFlotante`) y se dibuja como la lista de un Select: blanco, radio 12,
   sombra media, opciones con radio 8 y accent-50 al pasar o cuando es la
   vigente. */
.raiz {
  position: relative;
  display: inline-flex;
  max-width: 100%;
}
.raiz > :first-child {
  max-width: 100%;
}

.panel {
  position: fixed;
  z-index: var(--z-popover);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--s-1);
  padding: var(--s-3);
  overflow-y: auto;
  overscroll-behavior: contain;
  background: var(--surface-card);
  border: var(--bw-hair) solid var(--border-hair);
  border-radius: var(--r-panel);
  box-shadow: var(--sh-md);
  transform-origin: top center;
  animation: entrar var(--dur-fast) var(--ease-standard);
}
.panel[data-arriba] {
  transform-origin: bottom center;
  animation-name: entrarArriba;
}

.item {
  display: flex;
  align-items: center;
  gap: var(--s-4);
  width: 100%;
  min-height: calc(var(--h-control-md) - var(--s-2));
  padding: var(--s-2) var(--s-5) var(--s-2) var(--s-4);
  border: 0;
  border-radius: var(--r-md);
  background: transparent;
  color: var(--text-strong);
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: var(--fw-regular);
  text-align: left;
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background var(--dur-fast) var(--ease-standard);
}
.item[data-selected] {
  background: var(--surface-brand-faint);
}
.item:focus-visible {
  outline: none;
  background: var(--surface-brand-faint);
}
@media (hover: hover) {
  .item:hover:enabled {
    background: var(--surface-brand-faint);
  }
}
.item:disabled {
  color: var(--control-disabled-text);
  cursor: not-allowed;
}
.texto {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.detalle {
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-3xs);
  color: var(--text-subtle);
}
.tilde {
  display: inline-flex;
  color: var(--text-brand);
}
/* El punto de estado: 6px, el color del estado al que lleva la opción. */
.punto {
  flex: none;
  width: var(--s-3);
  height: var(--s-3);
  margin-inline: var(--s-2);
  border-radius: var(--r-full);
  background: var(--text-subtle);
}
.punto[data-tone="warning"] {
  background: var(--status-warning);
}
.punto[data-tone="brand"] {
  background: var(--surface-brand);
}
.punto[data-tone="success"] {
  background: var(--status-success);
}
.punto[data-tone="danger"] {
  background: var(--status-danger);
}

@keyframes entrar {
  from {
    opacity: 0;
    transform: scale(0.98) translateY(-2px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes entrarArriba {
  from {
    opacity: 0;
    transform: scale(0.98) translateY(2px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .panel {
    animation: none;
  }
  .item {
    transition: none;
  }
}
